var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnTutorialLock = function SvgIcnTutorialLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18.0001,
    r: 14,
    fill: "#7E8185"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5668C18.6001 20.5668 19.0867 20.0803 19.0867 19.4802C19.0867 18.88 18.6001 18.3935 18 18.3935C17.3998 18.3935 16.9133 18.88 16.9133 19.4802C16.9133 20.0803 17.3998 20.5668 18 20.5668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1867 15.3534V14.5201C22.1867 12.7201 21.7534 10.3334 18 10.3334C14.2467 10.3334 13.8134 12.7201 13.8134 14.5201V15.3534C11.9467 15.5868 11.3334 16.5334 11.3334 18.8601V20.1001C11.3334 22.8334 12.1667 23.6668 14.9 23.6668H21.1C23.8334 23.6668 24.6667 22.8334 24.6667 20.1001V18.8601C24.6667 16.5334 24.0534 15.5868 22.1867 15.3534ZM18 21.4934C16.8867 21.4934 15.9867 20.5868 15.9867 19.4801C15.9867 18.3668 16.8934 17.4668 18 17.4668C19.1067 17.4668 20.0134 18.3734 20.0134 19.4801C20.0134 20.5934 19.1134 21.4934 18 21.4934ZM14.9 15.2934C14.8467 15.2934 14.8 15.2934 14.7467 15.2934V14.5201C14.7467 12.5668 15.3 11.2668 18 11.2668C20.7 11.2668 21.2534 12.5668 21.2534 14.5201V15.3001C21.2 15.3001 21.1534 15.3001 21.1 15.3001H14.9V15.2934Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnTutorialLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_tutorial_lock.cf7bcaba.svg";
export { ForwardRef as ReactComponent };